import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Modal } from '@/src/elements/modal/Modal'
import { Typography } from '@/src/elements/text/Typography'
import { useTranslate } from '@/src/lang/useTranslate'

type TFraternityOnboardingCloseModalProps = {
  showModal: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const FraternityOnboardingCloseModal = ({
  showModal,
  onCancel,
  onConfirm,
}: TFraternityOnboardingCloseModalProps): ReactNode => {
  const { t } = useTranslate()

  return (
    <Modal
      showModal={showModal}
      showCancelButton
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmText={t('word.continue')}
      cancelText={t('word.cancel')}
      title={<FormattedMessage id="fraternity.onboarding.close.title" />}
      description=""
      classNames={{ title: 'px-4', body: 'gap-3 px-4' }}
    >
      <Typography>
        <FormattedMessage id="fraternity.onboarding.close.body" />
      </Typography>
      <Typography>
        <FormattedMessage id="fraternity.onboarding.close.footer" />
      </Typography>
    </Modal>
  )
}
